/* eslint-disable no-magic-numbers */
export const FONT_SIZE_LIST = {
  // // 坐标轴标签 10
  // 10, 11,
  // // 图例文字 12
  // 12, 13, 14, 16,
  // // 标题 18
  // 18, 20, 24
  axisName: 10,
  axisLabel: 10,
  legendLabel: 12,
  tooltipLabel: 12,
  axisPointerLabel: 10,
  seriesLabel: 10,
  titleLabel: 18
};
export const FONT_WEIGHT_LIST = {
  bold: 'bold',
  normal: 'normal',
  bolder: 'bolder',
  lighter: 'lighter',
  axisLabel: 500,
  axisName: 400,
  barLabel: 500
};
// 同一行高 待补充
export const LINE_HEIGHT_LIST = {
  tooltipLabel: 16
};

export const FONT_FAMILY_LIST = {
  axisLabel: 'THSJinRongTi-Medium',
  axisPointerLabel: 'THSJinRongTi-Medium',
  axisName: 'PingFangSC-Regular',
  seriesLabel: 'PingFangSC-Regular'
};
export const THS_FONTFAMILY = 'THSJinRongTi-Regular';
export const THS_FONTFAMILY_MEDIUM = 'THSJinRongTi-Medium';
export const PINGFANGSC_REGULAR = 'PingFangSC-Regular';

const FONT_COLOR = [0.84, 0.6, 0.4, 0.24];
/**
 * 坐标轴标签 1级
 * 图例标签 2级
 * 数据浮层（tooltip） 1级
 * 待补充
 */
type FontLevel = 1 | 2 | 3 | 4;

export const FONT_LEVEL_LIST: Record<string, FontLevel> = {
  LEVEL1: 1,
  LEVEL2: 2,
  LEVEL3: 3,
  LEVEL4: 4
};

/**
 * 返回不同等级的文字的颜色
 */
export function fontColor(level: FontLevel, colorMode?: 'light' | 'dark') {
  const mode = colorMode || 'light';
  const color = mode === 'light' ? 0 : 255;
  return `rgba(${color}, ${color}, ${color}, ${FONT_COLOR[level - 1]})`;
}
